<template>
    <div class="row m-2">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <p>Saya yang bertanda tangan di bawah ini:</p>
                </div>
                <div v-if="PasienInformation && Object.keys(PasienInformation).length > 0" class="col-12">
                    <table class="table table-borderless">
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">nama</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <template v-if="CurrentlyPrintingLetter">
                                    <span>{{ GuardianName }}</span>
                                </template>
                                <template v-else>
                                    <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                        <div class="row">
                                            <div class="col-4">
                                                <input v-model="GuardianName" type="text" class=" form-control" />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </div>
                                    </validation-provider>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">tanggal lahir</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <template v-if="CurrentlyPrintingLetter">
                                    <span>{{ GuardianDateBirth }}</span>
                                </template>
                                <template v-else>
                                    <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                        <div class="row">
                                            <date-picker :value-type="SuratPersetujuanDateFormat()"
                                                v-model="GuardianDateBirth" :format="SuratPersetujuanDateFormat()"
                                                type="date" :clearable="false" class="col-4"
                                                input-class="form-control"></date-picker>
                                        </div>
                                        <div class="row">
                                            <span class="col-4 text-danger">{{ errors[0] }}</span>
                                        </div>
                                    </validation-provider>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">jenis kelamin</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <template v-if="CurrentlyPrintingLetter">
                                    <span>{{ GuardianSex }}</span>
                                </template>
                                <template v-else>
                                    <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                        <div class="row">
                                            <div class="col-4">
                                                <input v-model="GuardianSex" type="text" class=" form-control" />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </div>
                                    </validation-provider>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">alamat</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <template v-if="CurrentlyPrintingLetter">
                                    <span>{{ GuardianAddress }}</span>
                                </template>
                                <template v-else>
                                    <validation-provider rules="required" v-slot="{ errors }" tag="div" class="w-100">
                                        <div class="row">
                                            <div class="col-4">
                                                <textarea v-model="GuardianAddress" type="text"
                                                    class="w-100 form-control"></textarea>
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </div>
                                    </validation-provider>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="pl-0">Menyatakan dengan sesungguhnya telah memberikan</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="pl-0">
                                <h6 class="my-3 text-uppercase font-weight-bold">
                                    persetujuan/penolakan
                                </h6>

                                <div class="d-flex align-items-center">
                                    <span class="mr-2">
                                        Untuk dilakukan tindakan medik berupa:
                                    </span>
                                    <template v-if="CurrentlyPrintingLetter">
                                        <span>{{ Tindakan }}</span>
                                    </template>
                                    <template v-else>
                                        <validation-provider rules="required" v-slot="{ errors }" tag="div">
                                            <input v-model="Tindakan" type="text" class="w-100 form-control" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </validation-provider>
                                    </template>
                                </div>

                                <p class="mt-3">Terhadap Saya Sendiri / Anak / Istri / Suami / Ayah / Ibu saya dengan</p>

                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">nama</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienName }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">no. rekam medis</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ PasienMRN }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">tanggal lahir</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ SuratPersetujuanDate(PasienDateBirth) }}</div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-capitalize pl-0" style="width: 20%">jenis kelamin</td>
                            <td class="d-flex align-items-center">
                                <span class="mr-4">:</span>
                                <div>{{ ParseJenisKelaminSurat(PasienSex) }}</div>
                            </td>
                        </tr>
                    </table>

                    <p>yang tujuan, sifat, dan perlunya tindakan medik tersebut di atas, serta risiko yang dapat
                        ditimbulkannya dan upaya mengatasinya telah dijelaskan dengan jelas oleh dokter atau tenaga medis
                        lainnya dan telah saya mengerti sepenuhnya.</p>

                    <p class="mb-4">Demikian pernyataan ini saya buat dengan penuh kesadaran dan tanpa paksaan.</p>

                </div>
            </div>
        </div>


        <div class="col-12 mt-4">
            <div class="row">
                <div class="col-12">
                    <p style="margin-bottom: 3px;">{{ KlinikInformation.KlinikCity }}, {{ SuratDate() }}</p>
                </div>
                <div class="col-12">
                    <p class="text-capitalize mb-4">jam: {{ SuratDateTimeRecorded }}</p>
                </div>

                <div class="col-12">
                    <div class="row mt-4">
                        <div class="col-6">
                            <p class="text-capitalize mb-4">pemberi pernyataan</p>
                            <template v-if="CurrentlyPrintingLetter">
                                <span class="d-block float-left" style="margin-top: 5em">
                                    {{ GuardianName }}
                                    <hr />
                                </span>
                            </template>
                            <template v-else>
                                <validation-provider style="margin-top: 5em" rules="required" v-slot="{ errors }" tag="div">
                                    <div class="mt-4 d-flex align-items-center">
                                        <div class="w-50">
                                            <input disabled :value="GuardianName" type="text" class=" form-control" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                            <hr />
                                        </div>
                                    </div>
                                </validation-provider>
                            </template>
                        </div>
                        <div class="col-6">
                            <p class="text-capitalize ml-4 pl-4 mb-4">petugas pemberi penjelasan</p>

                            <template v-if="CurrentlyPrintingLetter">
                                <span class="d-block float-left ml-4 pl-4" style="margin-top: 5em">
                                    {{ PetugasPemberiPernyataan }}
                                    <hr />
                                </span>
                            </template>
                            <template v-else>
                                <validation-provider style="margin-top: 5em" rules="required" v-slot="{ errors }" tag="div">
                                    <div class="ml-4 pl-4 mt-4 d-flex align-items-center">
                                        <div class="w-100">
                                            <div class="w-50">
                                                <input v-model="PetugasPemberiPernyataan" type="text"
                                                    class=" form-control" />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                </validation-provider>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <SuratPenunjangFormBaseDigitalSign />
        </div>
    </div>
</template>

<script>
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";
import axios from 'axios'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: 'This field is required'
});

import { SuratDate, SuratDateTime, SuratDatePickerFormat, SuratPersetujuanDateFormat, SuratPersetujuanDate } from '../../Helpers/DateSurat.js'
import { ParseJenisKelaminSurat } from '../../Helpers/ParseJenisKelaminSurat.js'

export default {
    name: 'SuratPersetujuanTindakanBody',
    components: {
        DatePicker: () => import('vue2-datepicker'),
        SuratPenunjangFormBaseDigitalSign: () => import('../Base/SuratPenunjangFormBaseDigitalSign.vue')
    },
    data() {
        return {
            GuardianName: null,
            GuardianDateBirth: null,
            GuardianSex: null,
            GuardianAddress: null,
            Tindakan: null,
            PasienName: null,
            PasienAge: null,
            PasienMRN: null,
            PasienDateBirth: null,
            PasienSex: null,
            PetugasPemberiPernyataan: null,
            SuratDateTimeRecorded: null,
        }
    },
    watch: {
        PasienInformation: {
            handler: function (val) {
                if (val && Object.keys(val).length > 0 && !this.LetterID) {
                    Object.keys(val).map(key => {
                        if (this[key] !== undefined) {
                            let tmpVal = val[key]
                            this.$set(this, key, tmpVal)
                        }
                    })
                }
            },
            deep: true,
            immediate: true
        },
        TataLaksanaPenunjang: {
            handler: function (val) {
                if (val) {
                    this.$nextTick(() => {
                        this.SetPasienTindakan()
                    })
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$emit('ComponentMounted')
            this.SuratDateTimeRecorded = this.SuratDateTime()
        })
    },
    computed: {
        ...mapState(['rekamMedis']),
        ...mapState('SuratPenunjangStore', ['CurrentlyPrintingLetter', 'PasienInformation', 'KlinikInformation', 'DokterInformation', 'LetterID', 'TransKlinikIDFromPembayaran', 'TataLaksanaPenunjang', 'AtPembayaranPage', 'LetterNumber']),
        ...mapGetters('SuratPenunjangStore', ['API_URL', 'TransKlinikID']),
        SuratPersetujuanTindakanEndpoint() {
            return `${this.API_URL}/surat-persetujuan-tindakan`
        },
        PayloadBackend() {
            return {
                nama: this.GuardianName,
                tanggalLahir: this.GuardianDateBirth,
                jenisKelamin: this.GuardianSex,
                alamat: this.GuardianAddress,
                tindakanMedikPasien: this.Tindakan,
                namaPasien: this.PasienName,
                umurPasien: this.PasienAge,
                nomorRekamMedisPasien: this.PasienMRN,
                tglLahirPasien: this.PasienDateBirth,
                jenisKelaminPasien: this.PasienSex,
                petugasPemberiPernyataan: this.PetugasPemberiPernyataan,
                jamSurat: this.SuratDateTimeRecorded,
                kotaSurat: this.KlinikInformation.KlinikCity,
                tanggalSurat: this.SuratDate(),
                transKlinikId: !this.AtPembayaranPage ? this.TransKlinikID : this.TransKlinikIDFromPembayaran,
                nomorSurat: this.LetterNumber
            }
        },
    },
    methods: {
        ...mapMutations(['SET_LOADING']),
        ...mapMutations('SuratPenunjangStore', ['SetLetterNumber']),
        SuratPersetujuanDateFormat,
        SuratDatePickerFormat,
        ParseJenisKelaminSurat,
        SuratDate,
        SuratDateTime,
        SuratPersetujuanDate,
        MapPrescriptionAndActions(target = 'obat') {
            if (this.TataLaksanaPenunjang && this.TataLaksanaPenunjang.length > 0) {
                return this.TataLaksanaPenunjang.map(item => {
                    if (item.kategori_layanan && item.kategori_layanan.toLowerCase() === target) {
                        return `${item.nama_layanan} ${item.quantity}`
                    } else {
                        return null
                    }
                }).filter(item => item).join(', ')
            } else if (this.rekamMedis.postData.tatalaksana && this.rekamMedis.postData.tatalaksana.length > 0) {
                return this.rekamMedis.postData.tatalaksana.map(item => {
                    if (item.kategori_layanan && item.kategori_layanan.toLowerCase() === target) {
                        return `${item.nama_layanan} ${item.quantity}`
                    } else {
                        return null
                    }
                }).filter(item => item).join(', ')
            }
        },
        SetPasienTindakan() {
            // this.Tindakan = this.MapPrescriptionAndActions('tindakan')
        },
        async GetData() {
            this.SET_LOADING(true)

            this.$nextTick(async () => {
                const { data } = await axios.get(`${this.SuratPersetujuanTindakanEndpoint}/${this.LetterID}`);

                this.GuardianName = data.nama
                this.GuardianDateBirth = data.tgl_lahir
                this.GuardianSex = data.jenis_kelamin
                this.GuardianAddress = data.alamat
                this.Tindakan = data.tindakan_medik_pasien
                this.PasienName = data.nama_pasien
                this.PasienAge = data.umur_pasien
                this.PasienMRN = data.nomor_rekam_medis_pasien
                this.PasienDateBirth = data.tgl_lahir_pasien
                this.PasienSex = data.jenis_kelamin_pasien
                this.PetugasPemberiPernyataan = data.petugas_pemberi_pernyataan
                this.SuratDateTimeRecorded = data.jam_surat

                this.SetLetterNumber(data.nomor_surat)

                this.$nextTick(() => {
                    this.SET_LOADING(false)
                })
            })
        },
        async UpdateData(PDFBase64) {
            const { data } = await axios.put(`${this.SuratPersetujuanTindakanEndpoint}/${this.LetterID}`, { ...this.PayloadBackend, PDFBase64 });

            return true
        },
        async SaveData(PDFBase64) {
            const { data } = await axios.post(`${this.SuratPersetujuanTindakanEndpoint}/create`, { ...this.PayloadBackend, PDFBase64 });

            return true
        },
    }
}
</script>

<style lang="scss">
.surat-persetujuan-tindakan {
    .table {
        td {
            padding-top: 0;
            padding-bottom: 14px;
        }
    }
}
</style>